import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'

import {useProjectId} from '../../../../../hooks/routes'
import {usePermission} from '../../../../../hooks/usePermission'
import {getIsReadOnly} from '../../../../../selectors'
import {Permission, ROOT_PROJECT_ID, stringifyId} from '../../../../../types'
import type {ProjectId} from '../../../../../types'
import {resolveRelative} from '../../../../../utils/url'
import {projectCreateHint} from '../../../../packages/Hints/HintItems/Hints.projectOverview'
import {useHint} from '../../../../packages/Hints/Hints.hooks'

import styles from './ProjectCreateSection.css'

import {useAppSelector} from 'src/hooks/react-redux'

type CreateType = {
  label: string
  showMode: string
}
export const CreateTypes = {
  PROJECT: {
    label: 'project',
    showMode: 'createProjectMenu',
  },
  SUBPROJECT: {
    label: 'subproject',
    showMode: 'createProjectMenu',
  },
  BUILD_TYPE: {
    label: 'build configuration',
    showMode: 'createBuildTypeMenu',
  },
}
type OwnProps = {
  className?: string
}
type ProjectCreateButtonProps = {
  projectId: ProjectId
  type: CreateType
  className?: string
}
export const generateCreateEntityLink = ({projectId, type}: ProjectCreateButtonProps): string =>
  resolveRelative('/admin/createObjectMenu.html', {
    projectId: stringifyId(projectId),
    showMode: type.showMode,
    cameFromUrl: location.href,
  })

export const createRootSubprojectLink = generateCreateEntityLink({
  projectId: ROOT_PROJECT_ID,
  type: CreateTypes.SUBPROJECT,
})
function ProjectCreateButton({projectId, type, className}: ProjectCreateButtonProps) {
  return (
    <Button
      className={classNames(styles.button, className)}
      href={generateCreateEntityLink({
        projectId,
        type,
      })}
      data-hint-container-id={projectCreateHint.id}
    >
      {`New ${type.label}...`}
    </Button>
  )
}

function ProjectCreateSection({className}: OwnProps) {
  const projectId = useProjectId()
  const is = useAppSelector(state => getIsReadOnly(state, projectId))
  const canEditProject = usePermission(Permission.EDIT_PROJECT, projectId)
  const canCreateSubProject = usePermission(Permission.CREATE_SUB_PROJECT, projectId)
  const canRenderSection = !is && (canEditProject || canCreateSubProject) && projectId != null
  useHint(canRenderSection && projectId != null ? projectCreateHint : null)
  return canRenderSection && projectId != null ? (
    <ProjectCreateButton className={className} projectId={projectId} type={CreateTypes.PROJECT} />
  ) : null
}

export default ProjectCreateSection
